import type { BenchmarkSnapshot } from "./types";

export function exportJson(snapshot: BenchmarkSnapshot): string {
  return JSON.stringify(snapshot, null, 2);
}

export function exportCsv(snapshot: BenchmarkSnapshot): string {
  const rows = [
    [
      "timestamp",
      "resolver",
      "endpoint",
      "resolver_status",
      "hostname",
      "query_status",
      "duration_ms",
      "method",
      "error_message",
      "median_ms",
      "success_rate",
      "cancelled"
    ]
  ];

  for (const result of snapshot.results) {
    for (const query of result.queryResults) {
      rows.push([
        snapshot.startedAt,
        result.resolverName,
        result.endpoint,
        result.status,
        query.hostname,
        query.status,
        formatCell(query.durationMs),
        query.methodUsed ?? "",
        query.errorMessage ?? "",
        formatCell(result.medianMs),
        formatCell(result.successRate),
        String(snapshot.cancelled)
      ]);
    }
  }

  return rows.map((row) => row.map(csvEscape).join(",")).join("\n");
}

export function downloadText(filename: string, content: string, type: string): void {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

function formatCell(value?: number): string {
  return typeof value === "number" ? String(Math.round(value * 100) / 100) : "";
}

function csvEscape(value: string): string {
  return /[",\n]/.test(value) ? `"${value.replaceAll('"', '""')}"` : value;
}
